import { store } from '@betacrew/jars-flux';
import { all, call, put, select, takeLatest, takeLeading } from 'redux-saga/effects';
import { PAGE_STATE } from '../../../constants/constants';
import { REQUEST_CONSENT_LOADING_STATES } from './constants';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { componentKey, setConsentRequestCountDetails, setConsentRequestFeesDetails, setConsentRequestPaymentDrawer, setLoadingState, setNoOfConsentRequestInfoModal } from './RequestConsentModalSlice';
import RecipientDataService from '../../../../../services/RecipientDataService';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';

export const { getConsentCount, getConsentMatchFee, getConsentUpdate } = {

    getConsentCount: (payload) => {
        return {
            type: "REQUEST_CONSENT/GET_COUNT",
            payload
        }
    },

    getConsentMatchFee: (payload) => {
        return {
            type: "REQUEST_CONSENT/GET_CONSENT_MATCH_FEE",
            payload
        }
    },
    getConsentUpdate: (payload) => {
        return {
            type: "REQUEST_CONSENT/GET_CONSENT_UPDATE",
            payload
        }
    }

}

function* getConsentCountAsync(action) {

    try {
        yield put(setLoadingState({ state: REQUEST_CONSENT_LOADING_STATES.CONSENT_REQUEST_COUNT_LOADING }))

        const { PayerID, RecipientIds, IsAllSelect } = action.payload;
        const requestPayload = { PayerID, RecipientIds, IsAllSelect }

        const response = yield RecipientDataService.getConsentDetails(requestPayload);
        const { Data, Message, Status } = response?.data;

        if (Status) {
            yield put(setConsentRequestCountDetails(Data))
        } else {
            yield put(addNotifications({
                heading: "Failed to get the consent request count",
                message: Message
            }))
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the consent request count", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REQUEST_CONSENT_LOADING_STATES.CONSENT_REQUEST_COUNT_READY }))
    }

}


function* getConsentUpdateAsync(action) {
    try {
        yield put(setLoadingState({ state: REQUEST_CONSENT_LOADING_STATES.CONSENT_PAYEE_LOADING }))
        const { PayerID, RecipientIds, IsAllSelect } = action.payload;

        const data = {
            PayerID: PayerID || "",
            RecipientIds: RecipientIds || [],
            IsAllSelect: IsAllSelect,
        }
        const response = yield RecipientDataService.consentUpdate(data);
        const {Message, Status } = response?.data;

        if (Status) {
            yield put(setNoOfConsentRequestInfoModal(false))
            yield put(addNotifications({ heading: "Consent Update", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({
                heading: "Failed to update consent status",
                message: Message
            }))
        }

    } catch (error) {
        console.log('err: ', error)
          yield put(addNotifications({ heading: "Failed to update consent status", message:"Ran into an error. Please try again or contact support"}));
      } finally {
        yield put(setLoadingState({ state: REQUEST_CONSENT_LOADING_STATES.CONSENT_PAYEE_READY }))
    }
}
function* getConsentMatchFeeAsync(action) {
    try {
        yield put(setLoadingState({ state: REQUEST_CONSENT_LOADING_STATES.CONSENT_MATCH_FEE_LOADING }))

        const { count } = action.payload;
        const response = yield RecipientDataService.consentMatchFee(count);
        const { Data, Message, Status } = response?.data;

        if (Status) {
            const fees = {
                OnlySeparateStatefiling: "false",
                TotalFilingFee: Data,
                FilingFee: Data,
                USPSFee: "0",
                TINMatchFee: "0",
                StateFee: "0",
                TINCount: "0",
                StateFilingCount: "0",
                USPSCount: "0",
                FormCount: "0"
            }

            yield put(setNoOfConsentRequestInfoModal(false))
            yield put(setConsentRequestFeesDetails(fees))
            yield put(setConsentRequestPaymentDrawer(true))
        } else {
            yield put(addNotifications({
                heading: "Failed to get the consent request count",
                message: Message
            }))
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the consent request count", message: error?.response?.data?.Message }));
      } finally {
        yield put(setLoadingState({ state: REQUEST_CONSENT_LOADING_STATES.CONSENT_MATCH_FEE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getConsentCount().type, getConsentCountAsync),
        takeLatest(getConsentMatchFee().type, getConsentMatchFeeAsync),
        takeLatest(getConsentUpdate().type, getConsentUpdateAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);